import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/snapchat': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM417.5 346.9C414 355 399.4 360.9 372.7 365.1 371.3 367 370.2 374.9 368.4 381 367.3 384.7 364.7 386.9 360.3 386.9H360.1C353.9 386.9 347.3 384 334.3 384 316.7 384 310.6 388 296.9 397.7 282.4 408 268.5 416.8 247.7 415.9 226.7 417.5 209.1 404.7 199.2 397.7 185.4 388 179.4 384 161.8 384 149.3 384 141.4 387.1 136 387.1 130.6 387.1 128.5 383.8 127.7 381.1 125.9 375 124.8 367 123.4 365.1 109.6 363 78.6 357.6 77.9 343.7 77.7 340.1 80.2 336.9 83.8 336.3 130.1 328.7 150.9 281.2 151.8 279.2 151.8 279.1 151.9 279 152 278.9 154.5 273.9 155 269.7 153.6 266.4 150.2 258.5 135.7 255.7 129.6 253.2 113.8 247 111.6 239.8 112.6 234.9 114.2 226.4 127 221.1 134.5 224.6 140.4 227.4 145.7 228.8 150.2 228.8 153.5 228.8 155.7 228 156.8 227.4 155.4 203.5 152.1 169.4 160.6 150.3 183.1 100 230.7 96 244.7 96 245.3 96 250.8 95.9 251.4 95.9 286.1 95.9 319.4 113.7 335.7 150.2 344.2 169.3 340.9 203.3 339.5 227.3 340.6 227.9 342.4 228.6 345.2 228.7 349.5 228.5 354.4 227.1 359.9 224.5 363.9 222.6 369.5 222.9 373.5 224.5 379.8 226.8 383.8 231.3 383.9 236.4 384 242.9 378.2 248.5 366.7 253 365.3 253.6 363.6 254.1 361.8 254.7 355.3 256.8 345.4 259.9 342.8 266.2 341.4 269.5 342 273.7 344.4 278.7 344.5 278.8 344.5 278.9 344.6 279 345.5 281 366.3 328.5 412.6 336.1 416.6 337.1 419.7 341.6 417.5 346.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/snapchat.js
// module id = MB6v
// module chunks = 144